import React from 'react';
import JobsTableRow from './JobsTableRow';
import { ClipboardList } from 'lucide-react';

const INK   = '#2B2620';
const STONE = '#8C8275';

export default function JobsTable({
  jobs = [],
  onJobClick,
  emptyMessage = "No jobs match the current filters"
}) {
  if (jobs.length === 0) {
    return (
      <div style={{
        padding: '60px 20px',
        textAlign: 'center'
      }}>
        <ClipboardList size={40} strokeWidth={1.5} color={STONE} style={{ marginBottom: '16px', opacity: 0.6 }} />

        <div style={{
          fontSize: '16px',
          fontWeight: '600',
          color: INK,
          marginBottom: '8px'
        }}>
          No Jobs Found
        </div>

        <div style={{
          fontSize: '14px',
          color: STONE
        }}>
          {emptyMessage}
        </div>
      </div>
    );
  }

  return (
    <div style={{
      background: 'var(--bg-tertiary)',
      borderRadius: '12px',
      border: '1px solid var(--cell-border)',
      overflow: 'hidden'
    }}>
      {jobs.map((job) => (
        <JobsTableRow
          key={job.id}
          job={job}
          onJobClick={onJobClick}
        />
      ))}
    </div>
  );
}